/**
 * i18n configuration
 */
export default defineI18nConfig(() => ({
    legacy: false,
    defaultLocale: "de-DE",
    warnHtmlMessage: false,
    allowComposition: true,
    globalInjection: true
}));
